import React, { useEffect, useState } from 'react'
import { closedTicketsTTR } from '../../../services/report.service';
import { useProject } from '../../../context/ProjectContext';
import { APIResponseModel } from '../../../models/api-call';
import SimpleBarChart from '../../common/Charts/SimpleBarChart';
import { SimpleBarChartDataItem } from '../../../models/charts';
import { LoadingSpinner } from '../../common/Icons';
import { fillRangeValues, getYTicks, setBarLabelAsTime } from './common';
import './widget-styles.css'
import { useNotification } from '../../../context/NotificationContext';


interface ResolutionTimeChartWidgetProps {
  title?: string
  filters: { from: string, to: string, [key: string]: any }
  height?: number
  reload?: boolean
}

const ResolutionTimeChartWidget: React.FC<ResolutionTimeChartWidgetProps> = ({
  title = '',
  filters,
  height = 400,
  reload = false
}) => {

  const { selectedProject } = useProject()
  const { showNotification } = useNotification()
  
  const [loading, setLoading] = useState<boolean>(true)
  const [dataChart, setDataChart] = useState<SimpleBarChartDataItem[]>([])

  const makeDataChart = (data: SimpleBarChartDataItem[]) => {
    setDataChart(fillRangeValues(filters.from, filters.to, data))
  }


  const initComponent = () => {
    if (filters.from && filters.to) {
      setLoading(true)
      Promise.all([closedTicketsTTR(selectedProject, filters)
      ]).then(function (result: APIResponseModel[]) {
        makeDataChart(result[0].data)
        setTimeout(() => setLoading(false), 1000)
      }).catch((error) => {
        setLoading(false)
        showNotification(<span>{error.response.data}</span>, 'error')
      });
    }
  }

  useEffect(initComponent, [reload])

  return (
    <React.Fragment>
      <div className='widget-section' style={{ flex: 1, height: height }}>
        {title && (<p className='title-widget'>{title}</p>)}
        {loading ? <div className='loading-widget'><LoadingSpinner /></div> : (
          <SimpleBarChart
            data={dataChart}
            tooltips={{}}
            yTicks={getYTicks(dataChart.map(item => item.y))}
            yTicksFormatter={(value) => `${value}h`}
            renderBarLabel={setBarLabelAsTime}
            showValuesAsTime
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default ResolutionTimeChartWidget;

